import { action, history, when, stores, i18n } from 'mutants-microfx';
import { toJS, runInAction, reaction } from 'mobx';
import { User, serverLog } from 'tplus-api';
import { ViewController } from 'mutants-appfx';
import { Message, Loading, ModalWraper, HardwareAPI } from 'tplus-components-touch';
import { platform } from 'mutants-util';
import { nativeMs, localStore as localStoreMs } from 'mutants-microfx';
import { PosInitData, UserData, TStore } from 'tplus-poslogin';
import ProductApi from '../api/ProductApi';
import PickUpApi from '../api/PickUpApi.js';
import CountApi from '../api/CountApi';
import tools from '../util/tools';
import common from '../util/common';
import { filterField } from '../fixedViewInfo';
import { drawerStore, voucherStateStore, withoutVoucherStore, QuickKeyStore, } from '../pageStores';
import localStore from '../localStore';
import { UnitChangeType } from '../commom/Enum';
import _cloneDeep from 'lodash/cloneDeep';
import { PromotionType, InvAmountsetting, DealAmountSetting, DistributionMode, SettleCode, } from '../commom/Enum';
import env from '../util/env.js';
import _get from 'lodash/get';
import '../commom/Challenger';
import operationLog from '../domain/operationLog/OperationLog';
import {AddLogProcessor} from '../domain/operationLog/AddLogProcessor'
import { Format } from '../commom/Format';
import UiCommon from '../util/uiCommon';
import {AuthProcess} from '../domain/retail/auth/AuthProcess'
const t = i18n.getFixedT(null, 'newretail');

class RetailOrderViewController extends ViewController {
  init() {
    const { isHorizontalSunMi } = platform || {};
    this.isHorizontalSunMi = !!isHorizontalSunMi;
    this.initPlanConfig();

    this.Sunmi_callScaleReading = false;
    this.isSetProductCursor = true;
    this.BalanceAutoConfirm = null;
    this.HangAutoPrintTicket = false;
    let setting_setData = localStoreMs.get("setting_setData");
    if (setting_setData && setting_setData.length != 0) {
      this.BalanceAutoConfirm = setting_setData.filter((data) => { return data.Name == 'BalanceAutoConfirm' })[0];
      this.HangAutoPrintTicket = setting_setData.filter((data) => { return data.Name == 'HangAutoPrintTicket' })[0];
    }
  }
  /* 是否自提状态 */
  getIsTakeTheir() {
    return common.getIsTakeTheir(this.data);
  }
  /* tuzha  是否原单退货 */
  isOriginalReturn() {
    return JSON.getCellValue(this.data, 'IsOriginalReturn');
  }

  /* tuzha  是否原单退货明细 */
  isOriginalReturnDetail(index) {
    return this.controller.isOriginalReturnDetail(index);
  }

  /* 检查电子秤是否可用 */
  checkScale() {
    if (voucherStateStore.scaleState !== '0') {
      return false;
    }
    return true;
  }

  /** 检查电子秤是否设置 */
  checkScaleIsSetting() {
    if(!window.sunMi_SystemProperties || window.sunMi_SystemProperties.systemModal != 'S2'){
      return voucherStateStore.scaleState !== '1' && voucherStateStore.scaleState !== '2';
    }
   return true;
  }

  // TextBoxModal调用电子秤读取数据
  callScaleByPlatformSub = async () => {
    this.callScaleByPlatformSubTimer = setInterval(async () => {
      let result = await this.callScaleByPlatform(true);
      if (result !== false && this.TextBoxVM_MO.formData) {
        this.TextBoxVM_MO.changeValue(this.TextBoxVM_MO.formData.Data[0],result);
      }
    }, 300)
  }

  // 统一电子秤调用方式
  callScaleByPlatform = async (isSub) => {
    let ret = 0;
    if (this.isHorizontalSunMi) {
      ret = await this.Sunmi_callScale(isSub);
    } else {
      ret = await this.callScale(isSub);
    }
    if (ret === false) return ret;
    ret = (ret + '').replace(/(^\s*)|(\s*$)/g, "");
    if (!Number.isNumber(ret)) {
      if(ret === "undefined" ){
        Message.warn(`警告！获取称重商品重量错误，请稍后重试。`);
      }else{
        Message.warn(`警告！获取称重商品重量为:${ret || ''}`);
      }
      ret = 0;
    }
    return this.handleQuantity(ret);
  }

  /* 商米调用电子秤 */
  async Sunmi_callScale(isSub) {
    if(!window.sunMi_SystemProperties || window.sunMi_SystemProperties.systemModal != 'S2'){
      if (
        voucherStateStore.scaleState === '2' ||
        voucherStateStore.scaleState === '1'
      ) {
        if(!isSub){
            Message.warn(t('称重请进行电子秤设置!!'));
        }
        return false;
      }
      if (voucherStateStore.scaleState === '3') {
        if(!isSub){
            Message.warn(t('请先进行电子秤调试!!'));
        }
        return false;
      }
    }
    return new Promise((resolve, reject) => {
      // 获取称重配置
      const scaleParams = this.getScaleParams();
      let noDataNumber = 0;
      if (!this.Sunmi_callScaleReading) {
        this.Sunmi_callScaleReading = true;
        this.openWeightSubClose = window.sunMi_OperatingCashier.openWeightSub(
          scaleParams,
          ret => {
            const { code, data } = ret;
            console.log('电子秤输入数值', data);
            if (code === 200) {
              if (data == 0) {
                this.openWeightSubClose();
                this.Sunmi_callScaleReading = false;
                if (!isSub) {
                  Message.warn(t('请先放置商品'));
                }
                resolve(0);
              }
              if (data + '' !== 'NaN') {
                noDataNumber = 0;
                this.Sunmi_callScaleReading = false;
                this.openWeightSubClose();
                resolve(data);
              }
            } else if (code == 99911) {
              noDataNumber++;
              if (noDataNumber >= 50) {
                noDataNumber = 0;
                this.openWeightSubClose();
                this.Sunmi_callScaleReading = false;
                // Message.warn(data + '：请检查称重设备正确配置、连接。');
                resolve(false);
              }
            } else {
              if (data + '' !== 'NaN') {
                this.Sunmi_callScaleReading = false;
                this.openWeightSubClose();
                if (!isSub) {
                  Message.warn(data + '：请检查称重设备正确配置、连接。');
                }
                resolve(false);
              }
            }
          }
        );
      } else {
        resolve(false);
      }
    })
  }

  /* 调用电子秤 */
  async callScale(isSub) {
    if (!isSub) {
      if (voucherStateStore.scaleState === '1') {
        Message.warn(t('称重仅在客户端中可用!'));
        return false;
      }
      if (voucherStateStore.scaleState === '2') {
        Message.warn(t('称重请进行电子秤设置!'));
        return false;
      }
      if (voucherStateStore.scaleState === '3') {
        Message.warn(t('请先进行电子秤调试!'));
        return false;
      }
    }
    return await new Promise((resolve, reject) => {
      nativeMs.setIpcRendererMethod('GetBalanceValue', null, ret => {
        let quantity;
        const dt = JSON.parse(ret);
        console.log('电子秤输入数值', dt);
        if (dt && dt.intace === 1) {
          quantity = dt.value;
        } else {
          if (!isSub) {
            Message.warn(t('环境已损坏:' + dt.error));
          }
          return false;
        }
        if (quantity == 0) {
          if (!isSub) {
            Message.warn(t('请先放置商品'));
          }
          resolve(0);
        }
        resolve(quantity);
      });
    })
  }

  /* 触发客显逻辑 */
  triggerGuestShow = (index) => {
    let { TotalTaxAmount, RetailDetails } = this.data || {}
    this.callGuestShow(1, { totalAmount: TotalTaxAmount, detail: RetailDetails[index] });
  }

  /* 调用客显 */
  async callGuestShow(dType, tdata) {
    if (voucherStateStore.guestShowState === '1') {
      console.log('客显报错:称重仅在客户端中可用!')
      return false;
    }
    if (voucherStateStore.guestShowState === '2') {
      console.log('客显报错:称重请进行客显设置!')
      return false;
    }
    if (voucherStateStore.guestShowState === '3') {
      console.log('客显报错:请先进行客显调试!')
      return false;
    }
    const { guestshow_welcome, guestshow_scan, guestshow_clear } = (localStoreMs && localStoreMs.get('portsetting_hardSet')) || {};
    if (!guestshow_scan) return;
    let other = '';
    switch (dType) {
      case 0: //欢迎
        other = guestshow_welcome;
        break;
      case 1: //明细
        if (tdata) {
          other = guestshow_scan;
          let { totalAmount = "", detail } = tdata;
          let inventory = JSON.getCellValue(detail, "Inventory.Name");
          let specification = JSON.getCellValue(detail, "Inventory.Specification");
          let unit = JSON.getCellValue(detail, "Unit.Name");
          let taxPrice = JSON.getCellValue(detail, "TaxPrice");
          let taxAmount = JSON.getCellValue(detail, "TaxAmount");
          let quantity = JSON.getCellValue(detail, "Quantity");
          other = other.replace('[商品名称]', inventory);
          other = other.replace('[商品规格]', specification || '');
          other = other.replace('[单位]', unit);
          other = other.replace('[数量]', quantity ? quantity.toFixed(2) : 0);
          other = other.replace('[含税单价]', taxPrice ? taxPrice.toFixed(2) : 0);
          other = other.replace('[含税金额]', taxAmount ? taxAmount.toFixed(2) : 0);
          other = other.replace('[含税总金额]', totalAmount ? totalAmount.toFixed(2) : 0);
        }
        break;
      case 2: //退款
        break;
      case 3: //收款
        break;
      case 4: //找零
        break;
      case 5: //清除
        other = guestshow_clear;
        break;
    }
    let params = JSON.stringify({ price: '', qty: '', total: '', inv: '', wel: '', other: other })
    console.log(`Send客显sendDataCusDisp:状态-1,参数-${params}`)
    HardwareAPI.sendDataCusDisp({ data: params, dataType: dType }, ret => { console.log(`Return客显sendDataCusDisp:状态-1,返回-${JSON.stringify(ret)}`) })
  }

  /* isLaborCost 是否劳务型 */
  getIsLaborCost(index) {
    //retaildetail 或者 index
    return this.data.RetailDetails[index].Inventory.IsLaborCost;
  }
  /* 是否有零售数据 （会员和明细） */
  isRetailData() {
    let data = this.data;
    if (
      !tools.isNull(data.Idmember) ||
      (data.RetailDetails && data.RetailDetails.length)
    )
      return true;
    return false;
  }

  async onDeductionIsRetailData({callback}) {
    let data = this.data;
    let result = false;
    if (
      !tools.isNull(data.Idmember) ||
      (data.RetailDetails && data.RetailDetails.length)
    ) {
      result = true;
    } else {
      result = false;
    }
    callback && callback(result)
  }

  /* =====================================左侧菜单区start===================================*/
  siderLefthome() {
    if (!this.isRetailData()) {
      history.replace('/');
      return;
    }
    let _this = this;
    ModalWraper.confirm({
      title: t('提示'),
      content: t('您当前正在开单,确定要离开当前页面吗？'),
      onOk: () => {
        _this.callGuestShow(5);
        history.replace('/');
      }
    });
  }
  //自提
  @action async siderLefttakeTheir() {
    const isExecuteTakeTheir = await this.isExecuteTakeTheir();
    if (isExecuteTakeTheir) this.executeTakeTheir();
  }
  async isExecuteTakeTheir() {
    return new Promise((resolve, reject) => {
      if (this.isRetailData()) {
        ModalWraper.confirm({
          title: t('提示'),
          content: t('您当前正在开单,确定要离开当前页面吗？'),
          onOk: async () => {
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      } else {
        resolve(true);
      }
    });
  }
  executeTakeTheir = async () => {
    await this.clearVoucherData();
    let formData = {
      Title: t('自提'),
      Data: filterField('takeTheir'),
      cancelable: true,
      check: result => {
        if (!result.getCode.trim().length) {
          return { Label: '您还没有输入提货码！' };
        }
      },
    };
    let formResult = await this.inputFormModal(formData);
    if (formResult === undefined) return;

    Loading.show({
      text: '获取自提信息...',
    });
    const result = await PickUpApi.getPickUpData(
      formResult.getCode,
      toJS(this.data.cut())
    );
    Loading.hide();
    const storeInfo = await TStore.restore();
    if (result.Idstore != storeInfo.storeID) {
      ModalWraper.confirm({
        title: t('提示'),
        content: t('自提门店不是当前门店！是否继续？'),
        onOk: () => {
          result.Idstore = storeInfo.storeID;
          result.IDDepartment_Store = PosInitData('IDDepartment_Store');
          runInAction(async () => {
            await this.controller.loadVoucherBody(result);
          });
        },
      });
    } else {
      await this.controller.loadVoucherBody(result);
    }

    let targetRetaildetail = this.data.RetailDetails[0];
    runInAction(() => {
      if (targetRetaildetail)
        JSON.setCellValue(targetRetaildetail, 'isCurrentOperate', true);
    });
  };

  //配送-待配送订单
  async siderLeftdelivery() {
    const refund = (status) => {
      if (status === true) {
        this.controller.init();
        stores.selectMemberStore.clearSeletMember();
      }
      drawerStore.init({ title: '待配送订单列表', key: 'deliverylist' });
    }
    if (this.isRetailData()) {
      ModalWraper.confirm({
        title: t('提示'),
        content: t('您当前正在开单,确定要进入待配送订单列表吗？'),
        onOk: () => {
          runInAction(() => {
            refund(true);
          })
        }
      })
    } else {
      refund(false)
    }
  }
  //配送-每次配送完成之后，要执行刷新机制。
  async executeDeliveryInventory() {
    this.controller.init();
  }

  //非原单退货
  @action async siderLeftrefundCurrent() {
    if (this.isOriginalReturn()) {
      Message.warn(t('您目前处于原单退货，禁止此操作。'));
      return;
    }
    if (common.getIsReturn(this.data)) {
      Message.warn(t('您已经在退货页面'));
      return;
    }

    const refund = async () => {
      await this.controller.initReturnInventory();
    };

    if (!this.isRetailData()) {
      // 退货初始化
      refund();
      return;
    }

    ModalWraper.confirm({
      title: t('提示'),
      content: t('您当前正在开单,确定要进入退货页面吗？'),
      onOk: () => {
        runInAction(() => {
          refund();
        });
      },
    });
  }

  //原单退货
  @action siderLeftrefundBefore() {
    const refund =  async(status) => {
      if (status === true) {
        this.controller.init();
        stores.selectMemberStore.clearSeletMember();
      }
      await this.SetKeyBoardDisplay(1)
      drawerStore.init({
        title: '原单退货',
        key: 'searchbill',
        type: 2,
        onHide: () => {
          this.SetKeyBoardDisplay(0)
        }
      });
    };
    if (this.isOriginalReturn() || this.isRetailData()) {
      ModalWraper.confirm({
        title: t('提示'),
        content: t('您当前正在开单,确定要进入退货页面吗？'),
        onOk: () => {
          runInAction(() => {
            refund(true);
          });
        },
      });
    } else {
      refund(false);
    }
  }
  executeReturnInventory = async dto => {
    console.log('原单退货信息:', dto);
    await this.controller.loadRefundVoucherBody(dto);
    //退货后 选中第一行
    this.selectRow({ index: 0 });
    //  runInAction(() => {
    //   const voucherVM=this.viewModel.getViewItem('Voucher');
    //   voucherVM.setCurRow({index:0});
    //   // JSON.setCellValue(this.data.RetailDetails[0], 'isCurrentOperate', true)
    // })
  };

  //挂单
  //@operationLog('hangUpOrder', '挂单')
  siderLeftlist() {
    if (this.getIsTakeTheir()) {
      Message.warn(t('您目前处于自提状态，禁止此操作。'));
      return;
    }
    if (this.isOriginalReturn()) {
      Message.warn(t('您目前处于原单退货，禁止此操作。'));
      return;
    }
    let data = toJS(this.data.RetailDetails);
    if (!data.length) return;
    let withoutVoucherDatas = localStore.get('withOutVoucher');
    withoutVoucherDatas = withoutVoucherDatas ? withoutVoucherDatas : [];
    let withoutVoucherData = {
      dataModel: toJS(this.data), //datamodel
      VoucherDate: tools.getCurDate(), //单据日期
      retailDetail: toJS(
        this.viewModel.items.find(el => el.type === 'Voucher').data
      ), //单据
    };

    withoutVoucherDatas.unshift(withoutVoucherData);
    localStore.set('withOutVoucher', JSON.stringify(withoutVoucherDatas));
    AddLogProcessor.execute("挂单",this.data.Code,"挂单成功")
   
    this.clearVoucherData();
    //执行挂单打印
    const horizontalPad = env.horizontalPad();
    const horizontalSunMi = env.horizontalSunMi();
    if (this.HangAutoPrintTicket && this.HangAutoPrintTicket.Value == '1' && !horizontalPad && !horizontalSunMi) {
      let rIndex = withoutVoucherDatas.findIndex(v => v.VoucherDate == withoutVoucherData.VoucherDate);
      this.printWithoutVoucherData({ index: rIndex }, true);
    }
    Message.success(t('挂单成功'));
  }

  //解挂
  @operationLog('hangOffOrder', '解挂')
  siderLeftlist2() {
    withoutVoucherStore.init();
  }

  //查询单据
  async siderLeftsearchbill() {
    await this.SetKeyBoardDisplay(1)
    drawerStore.init({
      title: '单据查询',
      key: 'searchbill',
      onHide:()=>{
        this.SetKeyBoardDisplay(0)
      }
    });
  }

  //查询库存
  async siderLeftsearchstock() {
    await this.SetKeyBoardDisplay(1)
    drawerStore.init({
      title: '库存查询',
      key: 'stock',
      onHide:()=>{
        this.SetKeyBoardDisplay(0)
      }
    });
  }

  SetKeyBoardDisplay = async (value) => {
    this.isHorizontalSunMi && window.android_setKeyBoard && await window.android_setKeyBoard.SetKeyBoardDisplay(value)
  }

  //查询会员
  async siderLeftmemberManager() {
    await this.SetKeyBoardDisplay(1)
    drawerStore.init({
      title: '会员管理',
      key: 'member',
      onHide:()=>{
        this.SetKeyBoardDisplay(0)
      }
    });
  }

  //会员新增
  async siderLeftmemberAdd() {
    await this.SetKeyBoardDisplay(1)
    stores.modalRouter.show({
      url: '/AA/MEMBER',
      title: '会员新增',
      className: 'memberAddModal',
      modalType: 'big',
      onHide: () =>{ 
        stores.modalRouter.hide('/AA/MEMBER')
        this.SetKeyBoardDisplay(0)
      },
    });
  }

  // 快捷键
  siderLeftquickKey() {
    console.log('快捷键');
    // let guideModal = this.viewModel.getViewItem('QuickKey');
    // guideModal.show((result) => {
    //   resolve(result);
    // });
    // QuickKeyStore.init({});
    QuickKeyStore.show({});
  }

  //锁屏功能更
  async siderLeftlock() {
    const userData = UserData();
    let lockPasswordFields = filterField('LockPassword');
    lockPasswordFields.forEach(field => {
      if (field.FieldName === 'account') {
        field.Value = userData.username;
        field.disabled = true;
      }
    });
    console.log('lockPasswordFields=======', lockPasswordFields);

    var unlockCount = 0; //错误录入次数
    const unlockCountThreshold = 10;
    const lockTime = 900000;

    let formData = {
      Title: '解锁屏幕',
      Data: lockPasswordFields,
      closeButton: false,
      check: out => {
        if (!out.LockPassword.trim().length) {
          return { Label: '输入为空,请重新输入', type: 'warn' };
        }
        if (unlockCount >= unlockCountThreshold) {
          return { Label: '密码错误超过10次,请15分钟后解锁', type: 'error' };
        }
        if (userData.password !== User.pwdEncrypt(out.LockPassword)) {
          unlockCount++;
          if (unlockCount >= unlockCountThreshold) {
            setTimeout(() => {
              unlockCount = 0;
            }, lockTime);
          }
          return { Label: '密码输入错误', type: 'error' };
        } else {
          unlockCount = 0;
          return;
        }
      },
      cancelable: false,
    };
    this.inputFormModal(formData);
  }

  //钱箱功能
  async siderLeftcashbox() {
    this.controller.openCashBoxByHand();
  }

  //删除withvoucher缓存
  clearWithoutVoucherData({ index }) {
    //判断删除单条还是全部
    if (!tools.isNull(index)) {
      //删除一条
      let withoutVoucherDatas = localStore.get('withOutVoucher') || [];
      withoutVoucherDatas.splice(index, 1);
      localStore.set('withOutVoucher', JSON.stringify(withoutVoucherDatas));
    }
  }

  //打印withvoucher缓存
  async printWithoutVoucherData({ index }, isJump) {
    try {
      let openLoading = {};
      let withoutVoucherDatas = localStore && localStore.get('withOutVoucher') || [];
      let dto = withoutVoucherDatas[index];
      if (dto) {
        if (!isJump) {
          openLoading = setTimeout(() => {
            Loading.show({
              text: '执行打印操作,请稍等...',
            });
          }, 1500);
        }
        await this.controller.printDraftRetail(dto);
        if (!isJump) clearTimeout(openLoading);
      } else {
        Message.warn(t(`打印参数有误`));
      }
      Loading.hide();
    } catch (error) {
      Loading.hide();
    }
  }

  //加载表单数据（挂单）
  async loadVoucher({ targetIndex }) {
    //数据检测
    let withoutVoucherDatas = localStore.get('withOutVoucher') || [];
    let withoutVoucherData = withoutVoucherDatas[targetIndex];
    if (!withoutVoucherData) return;

    let { dataModel } = withoutVoucherData;
    let isFinish = await this.controller.loadWithoutVoucherBody(dataModel); //加载datamodal
    if (isFinish) {
      /* 明细目标行为第一行 */
      this.selectRow({ index: 0 });
      /* 删除本地缓存 */
      this.clearWithoutVoucherData({ index: targetIndex });
    }
    return;
  }



  /*==================待配送订单数量获取事件===================== */
  doEcommerceUnSeedsCountEvent = async ({ fn }) => {
    console.log('Event-doEcommerceUnSeedsCountEvent:1');
    if (this.timerID) {
      console.log('Event-doEcommerceUnSeedsCountEvent:2');
      clearInterval(this.timerID);
    }
    await this.setEcommerceUnSeedsCount();
    this.timerID = setInterval(() => { this.setEcommerceUnSeedsCount() }, 1800000)
    if (fn && typeof fn == 'function') fn();
  }
  setEcommerceUnSeedsCount = async () => {
    let ret = await CountApi.GetEcommerceUnSeedsCount();
    console.log('待配送订单数量:' + ret)
    let operations = this.viewModel && this.viewModel.getViewItem('Operations');
    operations && operations.changeMenu(ret);
    localStoreMs && localStoreMs.set('ecommerceUnSeedsCount', ret)
  }
  /*==================待配送订单数量获取事件===================== */


  /* =====================================左侧菜单区end===================================*/

  /* =====================================添加商品逻辑开始start===================================*/
  /**
   *从库存查询中添加零售单明细
   *
   * @param {*} { inventory }
   * @memberof RetailOrderViewController
   */
  //抛物线效果
  shopAnimate() {
    try {
      let { x: x2, y: y2 } = voucherStateStore.carPosition;
      let { x: x1, y: y1 } = voucherStateStore.inventoryPosition;
      let el = voucherStateStore.el;
      Product.animate({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        dom: el,
      });
    } catch (e) {
      console.warn('shop animation', e);
    }
  }
  async addInventoryFromStock({ inventory }) {
    $T.debugger();
    console.log('addInventoryFromStock:' + JSON.stringify(inventory));
    if (inventory.Disabled == '1') {
      ModalWraper.info({
        content: t('该存货已停用！'),
      });
      return;
    }
    //tuzha 原单退货，且使用代金券结算，不能添加商品明细
    if (!this.checkAddInventory(this.data)) {
      return;
    }

    let inventoryParams = {};
    inventoryParams.Id = inventory.IdInventory;
    let productDetail = await this.getProductDetail(inventoryParams);

    let retailDetail = JSON.parse(productDetail.RetailDetail);
    retailDetail = this.data.createValue('RetailDetails', retailDetail);

    $T.debugger();
    runInAction(() => {
      this.controller
        .ConvertRetailDetailFromStockProcessor(inventory, retailDetail)
        .then(() => {
          $T.debugger();
          console.log(
            'addInventoryCheckFlow:' + JSON.stringify(retailDetail)
          );
          $T.debugger();
          runInAction(() => {
            productDetail.RetailDetail = JSON.stringify(retailDetail);
            this.addInventoryCheckFlow(productDetail);
          });

          $T.debugger();
        });
    });
    this.setInventoryFocus();
  }

  isNotNeedToSettingFocus(){
    const horizontalPad = env.horizontalPad();
    const currentRouter = stores.modalRouter.currentMoadl;

    return !!horizontalPad || currentRouter == '/AA/MEMBER'
  }

  //设定商品录入框焦点
  async setInventoryFocus() {
    const isNotNeedToSettingFocus = this.isNotNeedToSettingFocus();
    if (isNotNeedToSettingFocus) return;
    let input = document.getElementById('productPoint');
    let _this = this;
    setTimeout(() => {
      if (input && _this.isSetProductCursor === true) {
        input.focus()
      }
    }, 300);
  }

  // 设定会员、商品焦点
  async setMemberProductCursor() {
    const horizontalPad = env.horizontalPad();
    if (!!horizontalPad) return;
    let _this = this;
    let cursorDefault = localStoreMs && localStoreMs.get('cursorDefaultPosition');
    let input = null;
    if (cursorDefault === 'member') {
      input = document.getElementById('memberPoint');
    }
    if (cursorDefault === 'product') {
      input = document.getElementById('productPoint');
    }
    _this.isSetProductCursor = false;
    setTimeout(() => {
      if (input) input.focus();
      setTimeout(() => { _this.isSetProductCursor = true }, 1000)
    }, 400);
  }

  //获取商品明细
  async addInventory({ inventory }) {
    //tuzha 原单退货，且使用代金券结算，不能添加商品明细
    if (!this.checkAddInventory(this.data)) {
      return;
    }
    let productDetail = await this.getProductDetail(inventory);
    await this.addInventoryCheckFlow(productDetail);
    this.setInventoryFocus();
  }
  /**
   * 添加存货校验
   * @param {*} dto 
   */
  checkAddInventory(dto) {
    const isTakeTheir = this.getIsTakeTheir();
    if (isTakeTheir) {
      Message.warn(t('自提不允许添加商品'));
      return false;
    }

    let refundRetail = JSON.getCellValue(dto, 'refundretail');
    if (refundRetail) {
      let index = refundRetail.RetailPaymentDetails.findIndex(
        paymentDetail => {
          let settleStyle = paymentDetail.SettleStyle;
          if (settleStyle) {
            if (settleStyle.Code == SettleCode.Coupon) {
              return true;
            }
            if (settleStyle.Code == SettleCode.Integral) {
              return true;
            }
            if (settleStyle.Code == SettleCode.Storage) {
              return true;
            }
          }
          return false;
        }
      );
      if (index > -1) {
        Message.warn('使用代金券、积分抵现或储值卡结算的原单退货不允许添加商品');
        return false;
      }
    }

    return true;
  }

  /* 获取存货详情 */
  async getProductDetail(inventory) {
    Loading.show({
      target: 'product',
      text: '获取商品明细...',
      opacity: 0.3
    });
    $T.debugger();
    let isReturn = common.getIsReturn(this.data);
    let productDetail = await ProductApi.getProductDetail({
      IdInventory: inventory.Id,
      IsReturn: isReturn,
      BarCode: inventory.BarCode,
      SerialNumberId: inventory.SerialNumberId,
      dto: this.data
    });
    Loading.hide();
    console.log('添加商品接口=====', productDetail);
    return productDetail;
  }

  isSupportFeedback(info) {
    const verticalTouch = env.verticalTouch();
    if (verticalTouch) {
      //竖屏信息不完整  阻塞添加商品
      Message.toast(`商品信息${info}有误，无法识别此商品！`);
      return false;
    }
    return true;
  }

  handleQuantity(quantity) {
    let scaleParams = this.getScaleParams();
    let priceUnit = scaleParams && scaleParams.price_unit;
    if (priceUnit) {
      if (priceUnit === 'kg2') {
        return quantity * 2;
      } else if(priceUnit === 'kg20') {
        return quantity * 20;
      } else if(priceUnit === 'kg1000') {
        return quantity * 1000;
      } else {
        return quantity;
      }
    }
    return quantity;
  }

  //添加商品视图控制逻辑
  async addInventoryCheckFlow(productDetail) {
    const verticalTouch = env.verticalTouch();
    const horizontalPad = env.horizontalPad();
    let RetailDetail, RetailInventory, RetailDetailUpdate = {};
    const isReturn = common.getIsReturn(this.data);
    RetailDetail = JSON.parse(productDetail.RetailDetail);
    RetailDetail = this.data.createValue('RetailDetails', RetailDetail);
    let Inventory = RetailDetail.Inventory;
    //针对序列号逻辑的处理。
    const { IsSerialNumber } = Inventory || {};
    const { SerialNumber } = RetailDetail || {};
    if ((!isReturn || this.isOriginalReturn()) && IsSerialNumber && !SerialNumber) {
      Message.warn(t('此为序列号商品，请在商品录入框中录入序列号！'));
      return false;
    }
    //是否已存在相同序列号商品
    let sFlag = this.data.RetailDetails.find(v => {
      if (v && v.Inventory.IsSerialNumber && v.SerialNumber == SerialNumber && v.Inventory.ID == Inventory.ID) {
        return true;
      }
      return false;
    })
    if (sFlag) {
      Message.warn(t('已存在该序列号商品！'));
      return false;
    }
    let inventoryinfo = tools.getDynamicProperty(
      Inventory.DynamicPropertyKeys,
      Inventory.DynamicPropertyValues,
      'inventoryinfo'
    );
    RetailInventory = JSON.parse(inventoryinfo);
    console.log('RetailDetail=====', RetailDetail);
    console.log('RetailInventory=====', RetailInventory);

    /* 称重商品获取重量 */
    const checkCanWeighFromBarCode = this.controller[
      'checkCanWeighFromBarCode'
    ];
    const isWeigh = typeof checkCanWeighFromBarCode == 'function'
      ? checkCanWeighFromBarCode(RetailDetail)
      : RetailDetail.Inventory.IsWeigh;
    if (isWeigh && !verticalTouch && !horizontalPad) {
      let isBalanceCanChange = PosInitData('isBalanceCanChange');
      if (
        (isBalanceCanChange == '1' && this.checkScaleIsSetting() === true) ||
        isBalanceCanChange !== '1'
      ) {
        let quantity = false;
        // 获取称重
        quantity = await this.callScaleByPlatform();
        // TODO: 判断条件应该为参数设置的条件 
        if (!(this.BalanceAutoConfirm && this.BalanceAutoConfirm.Value == 1)) {
          // 单价
          const TaxPrice = RetailDetail.TaxPrice;
          let field = filterField('Quantity');
          const inputLimit = common.getInputLimit('quantity');
          field[0] = {
            ...field[0],
            Value: quantity,
            TaxPrice,
            ...inputLimit,
            Title: '重量',
          };
          let inputData = {
            Title: t('零售数量'),
            Data: field,
            cancelable: true,
          };
          let quantityResult = await this.inputFormModal({
            ...inputData,
            BalanceAutoConfirm: true,
          }) 
          clearInterval(this.callScaleByPlatformSubTimer)
          quantity = quantityResult.Quantity;
        }
        if (quantity === false || quantity === 0) return;
        // 数量格式化 按T+精度
        quantity = (new Format()).FormatQuantity(quantity);
        RetailDetailUpdate.Quantity = isReturn ? -quantity : quantity;
      }
    }


    /* 自由项选择 */
    const inventoryFreeItemObj = {
      head: '自由项选择',
      data: {
        title: {
          name: t('商品名称'),
          value: RetailInventory.Name,
        },
        body: RetailInventory.FreeItems,
      },
      cancelEnable: true,
    };
    if (
      this.isPopupFreeItem(RetailDetail, RetailInventory) &&
      inventoryFreeItemObj.data.body &&
      inventoryFreeItemObj.data.body.length > 0
    ) {
      if (!this.isSupportFeedback('自由项')) return;
      var result = await this.inputFreeItemsModal(inventoryFreeItemObj);
      if (!result) {
        return;
      }
      RetailDetailUpdate.FreeItems = result;
      result.forEach(el => {
        JSON.setCellValue(RetailDetail, el.Name, el.Value);
      });
    }

    //	若商品为浮动换算且未设置换算率，则弹出数量2录入界面
    if (this.isPopupQuantity2(RetailDetail, RetailDetailUpdate)) {
      if (!this.isSupportFeedback('浮动换算且未设置换算率')) return;
      let Data = filterField('Quantity2');

      let voucherVM = this.viewModel.getViewItem('Voucher');
      let quantityField = voucherVM.voucherDetail.find(
        el => el.FieldName === 'Quantity'
      );
      (Data[0].maxLength = quantityField.MaxLength), (Data[0].precisionLength =
        quantityField.Precision);

      const isLaborCost = RetailDetail.Inventory.IsLaborCost;
      if (!isLaborCost && !isReturn) Data[0].type = 'positive';

      let formDataQuantity2 = {
        Title: t('数量2'),
        Data: Data,
        cancelable: true,
      };
      let formResultQuantity2 = await this.inputFormModal(formDataQuantity2);

      if (formResultQuantity2 === void 0) {
        return;
      }
      RetailDetailUpdate.Quantity2 = formResultQuantity2.Quantity2;
    }

    // 弹出批号
    if (this.isPopupBatch(RetailDetail, RetailDetailUpdate)) {
      if (!this.isSupportFeedback('批号')) return;
      let batchs = await this.checkBatch(RetailDetail, true, null);
      if (batchs === void 0) {
        return;
      } //不要去掉
      //如果没有取到批号信息
      if (batchs.length !== 0)
        RetailDetailUpdate.Batchs = batchs.filter(el => el.Quantity != 0);
    }

    //校验零售价必录
    let noPrice = RetailInventory.NoPrice;
    if (noPrice) {
      if (!this.isSupportFeedback('零售价')) return;
      let Data = filterField('RetailPrice');
      let limitObj = common.getInputLimit('price');
      if (Data) {
        Data[0].maxLength = limitObj.maxLength;
        Data[0].precisionLength = limitObj.precisionLength;
        Data[0].type = 'positive';
      }
      let formData = {
        Title: t('零售价'),
        Data: Data,
        cancelable: true,
      };
      let formResult = await this.inputFormModal(formData);
      if (formResult === void 0) {
        return;
      }
      RetailDetailUpdate.RetailPrice = formResult.RetailPrice;
    }
    // 若选项“必须输入营业员”为是，且当前行的导购为空，则弹出导购录入界面
    let isMustGuide = PosInitData('isMustGuide');
    let idPerson = PosInitData('Idperson');

    let idPersonHeader = this.data.Idperson;
    if (
      isMustGuide === '1' &&
      tools.isNull(idPerson) &&
      tools.isNull(idPersonHeader) &&
      !verticalTouch
    ) {
      const result = await this.inputGuide();
      const { guide, choice } = result;
      if (guide) {
        RetailDetailUpdate.person = guide;
        RetailDetailUpdate.choice = choice;
      }
    }

    //弹出序列号
    if ((isReturn && !this.isOriginalReturn()) && IsSerialNumber && !SerialNumber) {
      let retSerialNumber = await this.SerialNumberVM(Inventory.Name);
      const { field1, field2 } = retSerialNumber;
      RetailDetailUpdate.SerialNumber = field1.Value;
      RetailDetailUpdate.SerialNumberMemo = field2.Value;
    }

    runInAction(async () => {
      console.log('添加商品Message', RetailDetail, RetailDetailUpdate);
      await this.controller.addInventory(RetailDetailUpdate, RetailDetail);
      let rIndex = this.controller.getRowIndex(RetailDetail);
      this.selectRow({ index: rIndex });
      this.triggerGuestShow(rIndex);
    });
    return;
  }

  /**
   * 是否弹出批号
   * @param {*} RetailDetail
   * @param {*} RetailDetailUpdate
   */
  isPopupBatch(RetailDetail, RetailDetailUpdate) {
    // 存货
    let inventory = RetailDetail.Inventory;

    // 是否启用批号
    let isBatch = inventory.IsBatch;
    if (!isBatch) {
      return false;
    }
    if (!String.isNullOrEmpty(RetailDetail.Batch)) {
      // 明细中有批号信息
      return false;
    }

    // 批号/有效期必录
    let isBatchNumberViladate = PosInitData('Isbatchnumberviladate');
    // 退货自动取批号
    let returnAutoBatch = PosInitData('ReturnAutoBatch');

    let isValidateBatch = false;
    if ('1' === isBatchNumberViladate && Number(RetailDetail.Quantity) > 0) {
      isValidateBatch = true;
    }

    if ('1' != returnAutoBatch && RetailDetail.Quantity < 0) {
      // 红单，出库单没有自动取批号的场合
      isValidateBatch = true;
    }
    return isValidateBatch;
  }
  /**
   *是否弹出数量2
   *
   * @param {*} RetailDetail
   * @param {*} RetailDetailUpdate
   * @returns
   * @memberof RetailOrderViewController
   */
  isPopupQuantity2(RetailDetail, RetailDetailUpdate) {
    if (RetailDetail.Unit.IsSingleUnit) {
      return false;
    }
    if (RetailDetail.Unit.ChangeType1.Id == UnitChangeType.Fixed) {
      // 固定多计量的场合
      return false;
    }
    let batchs = RetailDetailUpdate.Batchs;

    if (batchs && batchs.length >= 0) {
      let index = batchs.findIndex((detail, index, arr) => {
        if (!detail.Quantity2) {
          return true;
        }
      });
      if (index > 0) {
        // 弹数量2
        return true;
      }
    }
    if (RetailDetail.Quantity2 === 0) {
      return false;
    } else if (!RetailDetail.Quantity2) {
      // 明细没有数量2的场合，弹出数量2
      return true;
    }
    return false;
  }
  /**
   * 是否弹出自由现
   * 当启用的自由项全部有值时不弹出，否则弹出
   * @param {*} detail
   */
  isPopupFreeItem(detail, RetailInventory) {
    if (!detail) {
      return false;
    }
    let isPop = false;
    let inventory = detail.Inventory;
    for (let index = 0; index < 10; index++) {
      const userfreeitem = 'userfreeitem' + index.toString();
      const freeitem = 'freeitem' + index.toString();
      let userfreeitemValue = JSON.getCellValue(inventory, userfreeitem);
      let freeitemValue = JSON.getCellValue(detail, freeitem);
      if (userfreeitemValue && userfreeitemValue + '' != '0') {
        // 启用自由项
        if (!freeitemValue) {
          isPop = true;
        } else {
          RetailInventory.FreeItems.forEach(el => {
            if (el.Name.toUpperCase() === freeitem.toUpperCase())
              el.Value = freeitemValue;
          });
        }
      }
    }
    return isPop;
  }
  /**
   * 是否启用自由项
   * @param {*} detail 
   */
  isEnableFreeItem(detail) {
    let inventory = detail.Inventory;
    for (let index = 0; index < 10; index++) {
      const userfreeitem = 'userfreeitem' + index.toString();
      const freeitem = 'freeitem' + index.toString();
      let userfreeitemValue = JSON.getCellValue(inventory, userfreeitem);
      if (userfreeitemValue && userfreeitemValue + '' != '0') {
        return true;
      }
    }
    return false;
  }
  //单条商品返回逻辑
  async justOneResultCallBack(productDetail) {
    if (!this.checkAddInventory(this.data)) {
      return;
    }
    this.addInventoryCheckFlow(productDetail);
    console.log('justOneResultCallBack========data', productDetail);
  }

  /* =====================================添加商品逻辑开始end===================================*/

  /* =====================================公共的弹出框逻辑start===================================*/
  //打开一个表单录入事件
  async inputFormModal(formData) {
    return await new Promise((resolve, reject) => {
      this.TextBoxVM_MO = this.viewModel.getViewItem('TextBoxModal');
      this.TextBoxVM_MO.inputForm(
        {
          ...formData,
        },
        resolve
      );
      const { BalanceAutoConfirm } = formData;
      if (BalanceAutoConfirm) this.callScaleByPlatformSub();
    });
  }

  //自由项必录
  async inputFreeItemsModal(inventoryFreeItemObj) {
    return await new Promise((resolve, reject) => {
      let FreeItemsVM = this.viewModel.getViewItem('FreeItemsModal');
      FreeItemsVM.input(inventoryFreeItemObj, resolve);
    });
  }

  //打开批号录入框
  async checkBatch(retailDetail, cancelEnable, batchMsg) {
    return await new Promise((resolve, reject) => {
      let BatchModal = this.viewModel.getViewItem('BatchModal');
      BatchModal.init(
        {
          retailDetail: retailDetail,
          cancelEnable,
          batchMsg,
        },
        resolve
      );
    });
  }

  /* =====================================公共的弹出框逻辑end===================================*/

  /* =====================================存货表格操作逻辑start===================================*/

  selectRow({ index = 0 }) {
    runInAction(() => {
      const voucherVM = this.viewModel.getViewItem('Voucher');
      voucherVM.setCurRow({ index });
    });
    this.controller.rowClick && this.controller.rowClick({ index });
  }
  //明细fileld改变
  async updateFieldFlow({ index, record, fieldName }) {
    $T.debugger();
    if ('TaxPrice' == fieldName) {
      if (!this.checkUpdatePrice('单价', index)) {
        return;
      }
    }
    if ('Quantity' == fieldName) {
      if (!common.getIsModifyQuantityAuth()) return;
      if (!this.checkQuantity('数量', index)) {
        return;
      }
    }

    let fieldDate = filterField(fieldName);
    fieldDate = this.updateFieldFlowLimit(fieldDate, index, record);
    let formData = {
      Title: fieldDate[0].Title,
      Data: fieldDate,
      cancelable: true,
    };

    let data = await this.inputFormModal(formData);
    if (data === void 0) return;
    this.updateBodyItem({
      index,
      record: {
        ...record,
        ...data,
      },
    });
  }

  updateFieldFlowLimit(fieldDate, index, record) {
    const isReturn = common.getIsReturn(this.data);
    const voucherVM = this.viewModel.getViewItem('Voucher');
    let field;
    const isLaborCost = this.getIsLaborCost(index);
    return fieldDate.map(el => {
      if (el.FieldName === 'Quantity') {
        field = voucherVM.voucherDetail.find(
          el => el.FieldName === 'Quantity'
        );
        el.maxLength = field.MaxLength;
        el.precisionLength = field.Precision;
        if (!isLaborCost && !isReturn) el.type = 'positive';
      }
      if (el.FieldName === 'TaxPrice') {
        field = voucherVM.voucherDetail.find(
          el => el.FieldName === 'TaxPrice'
        );
        (el.maxLength = field.MaxLength), (el.precisionLength =
          field.Precision);
        el.type = 'positive';
      }
      //uiState 控制
      let uiState = record.uiState || {};
      uiState = uiState[el.FieldName] || {};

      const { max, min } = uiState;
      const positive = uiState.abs;
      if (positive) el.type = 'positive';
      el.max = max;
      el.min = min;

      return el;
    });
  }

  async deleteBodyItem({ index }) {
    const isTakeTheir = this.getIsTakeTheir();
    if (isTakeTheir) {
      Message.warn(t('自提商品不能删除，如需退货，请将商品数量改为0'));
      return;
    }
    (await this.controller.deleteBodyItem) && this.controller.deleteBodyItem({ index });
    //设置选中行
    let retailDetails = this.data.RetailDetails;
    if (!retailDetails[index]) index--;
    this.selectRow({ index });
    this.triggerGuestShow(index);
  }

  async updateBodyItem({ index, record }) {
    let _this = this;
    let updateRetailDetail = toJS(this.data.RetailDetails[index]);
    for (let key in record) {
      let oldData = _get(updateRetailDetail, key);
      let newData = record[key];
      if (typeof oldData === 'object' || typeof newData === 'object') continue;
      if (newData != oldData) {
        let updateProp = {
          name: key,
          oldData,
          newData,
        };
        if ('Quantity' == key) {
          if (!await this.checkQuantity('数量', index, newData)) {
            return;
          }
        }
        await runInAction(() => {
          this.controller.updateBodyItem(updateRetailDetail, { index, updateProp });
        })
        this.triggerGuestShow(index);
      }
    }
  }

  /* =====================================存货表格操作逻辑end===================================*/

  /* =====================================底部按钮区域的操作start===================================*/

  //入口方法  事件由此方法分发
  async voucherOperationUpdate({ operationName, targetIndex }) {
    await this[operationName](targetIndex);
  }

  /* 是否执行判断 */
  isExecute(config) {
    if ('takeTheir' in config) {
      const isTakeTheir = this.getIsTakeTheir();
      if (isTakeTheir !== config.takeTheir) {
        let message = '';
        if (isTakeTheir) {
          message = '自提';
        } else {
          message = '非自提';
        }
        Message.warn(t(`${message}状态不允许使用此功能`));
        return false;
      }
    }

    if ('have' in config) {
      //有明细才可以执行
      const retailDetails = this.data.RetailDetails;
      if (!!retailDetails.length != config.have) {
        if (!retailDetails.length) {
          Message.warn(t('请先添加商品后再执行此操作!'));
          return false;
        }
      }
    }

    if ('single' in config) {
      const retailDetail =
        this.data.RetailDetails && this.data.RetailDetails[config.index];
      if (!!retailDetail != config.single) {
        if (!retailDetail) {
          Message.warn(t('请先添加商品后再执行此操作!'));
          return false;
        }
      }
    }

    //tuzh 原单退货
    if ('originalReturn' in config) {
      if (this.isOriginalReturnDetail(config.index) != config.originalReturn) {
        Message.warn(t('原单退货商品不执行此操作!'));
        return false;
      }
    }

    // 电子秤功能的一些校验
    if ('balance' in config) {
      if (voucherStateStore.scaleState === '1') {
        Message.warn(t('称重仅在客户端中可用!'));
        return false;
      }
      if (voucherStateStore.scaleState === '2') {
        Message.warn(t('称重请进行电子秤设置!!'));
        return false;
      }
      if (voucherStateStore.scaleState === '3') {
        Message.warn(t('请先进行电子秤调试!!'));
        return false;
      }
    }

    //序列号检验
    if ('serialNumber' in config) {
      const isReturn = common.getIsReturn(this.data);
      const retailDetail = this.data.RetailDetails && this.data.RetailDetails[config.index];
      if(!retailDetail) return true;
      const { Inventory: { IsSerialNumber }, SerialNumberId } = retailDetail || {};
      if (IsSerialNumber) {
        if (SerialNumberId) {
          Message.warn(t('此为序列号带出商品,禁止修改相关属性！'));
          return false;
        }
        if (!isReturn || this.isOriginalReturn()) {
          let warnInfo = (config.checkSerial == true) ? '非原单退货才可使用此功能！' : '此为序列号商品，当前功能不可使用!';
          Message.warn(t(warnInfo));
          return false;
        }
      } else if (!IsSerialNumber && config.checkSerial == true) {
        Message.warn(t('不属于序列号商品，当前功能不可使用！'));
        return false;
      }
    }
    return true;
  }

  /* 称重 */
  async Balance(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex
    });
    if (!isExEcute) return false;
    let retailDetail =
      this.data.RetailDetails && this.data.RetailDetails[targetIndex];
    /* 是否是称重商品 */
    const isWeigh = retailDetail.Inventory.IsWeigh;
    if (!isWeigh) {
      Message.warn('此商品不是称重商品');
      return false;
    }
    /* 打开电子秤读取数据 */
    let quantity = false;
    // 获取称重
    quantity = await this.callScaleByPlatform();
    if (quantity === false || quantity === 0) return false;
    quantity = (new Format()).FormatQuantity(quantity);
    const isBalanceCanChange = PosInitData('isBalanceCanChange'); //是否可以手动修改
    if (isBalanceCanChange == '1') {
      let field = filterField('Quantity');
      const inputLimit = common.getInputLimit('quantity');
      field[0] = {
        ...field[0],
        Value: quantity,
        ...inputLimit,
      };
      let inputData = {
        Title: t('商品重量'),
        Data: field,
        cancelable: true,
      };
      const quantityResult = await this.inputFormModal(inputData);
      if (quantityResult) quantity = quantityResult.Quantity;
    }
    await runInAction(() => {
      this.controller.updateQuantity &&
        this.controller.updateQuantity(retailDetail, {
          index: targetIndex,
          updateProp: {
            oldData: retailDetail.Quantity,
            newData: quantity,
          },
        });
    });
  }

  getScaleParams = () => {
    // 获取称重配置
    const scaleParamsStore = localStoreMs && localStoreMs.get('portsetting_hardSet');
    console.log(scaleParamsStore);
    let port = scaleParamsStore.scale_port;
    let balance = scaleParamsStore.scale_type;
    let arr = [];
    arr.push(
      scaleParamsStore.scale_baud,
      scaleParamsStore.scale_check,
      scaleParamsStore.scale_bit,
      scaleParamsStore.scale_stop,
      scaleParamsStore.price_unit
    );
    let setting = arr.join(',');
    const scaleParams = {
      balance: balance,
      port: port,
      setting: setting,
      scale_baud: scaleParamsStore.scale_baud,
      price_unit: scaleParamsStore.price_unit
    };
    return scaleParams;
  }

  //SingleMemo商品备注
  async SingleMemo(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex
    });
    if (!isExEcute) return false;
    //备注商品
    let fieldName = 'SingleMemo';
    let MemoVM = this.viewModel.getViewItem('Memo');
    let retailDetail = this.data.RetailDetails[targetIndex];
    let inventoryName =
      (retailDetail.Inventory && retailDetail.Inventory.Name) || '';

    await this.SetKeyBoardDisplay(1)
    let result = await MemoVM.init({
      title: '商品备注',
      data: {
        head: {
          name: '商品名称',
          value: inventoryName,
        },
        body: {
          ControlType: 'TextArea',
          FieldName: fieldName,
          Value: this.data.RetailDetails[targetIndex].Memo,
        },
      },
      cancelEnable: true,
    });
    await this.SetKeyBoardDisplay(0)
    const bizControllerName = `update${fieldName}`;
    if (result) {
      runInAction(() => {
        this.controller[bizControllerName] &&
          this.controller[bizControllerName](result.Value, targetIndex);
      });
    }
  }

  //WholeMemo整单备注
  async WholeMemo() {
    let fieldName = 'WholeMemo';
    let MemoVM = this.viewModel.getViewItem('Memo');
    await this.SetKeyBoardDisplay(1)
    let result = await MemoVM.init({
      title: '整单备注',
      data: {
        body: {
          ControlType: 'TextArea',
          FieldName: fieldName,
          Value: this.data.Memo
        }
      },
      cancelEnable: true,
    });
    await this.SetKeyBoardDisplay(0)
    const bizControllerName = `update${fieldName}`;
    if (result) {
      runInAction(() => {
        this.controller[bizControllerName] &&
          this.controller[bizControllerName](result.Value);
      })
    }
  }

  //修改数量Quantity2
  async Quantity2(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      serialNumber: true
    });
    if (!isExEcute) return false;
    const fieldName = 'Quantity2';
    if (!this.checkQuantity('数量2', targetIndex)) {
      return false;
    }
    let retailDetail = this.data.RetailDetails[targetIndex];
    let isSingleUnit = retailDetail.Unit.IsSingleUnit;
    if (isSingleUnit) {
      // 单计量存货
      Message.warn(t('单计量存货不能修改数量2!'));
      return false;
    }

    let data = filterField(fieldName);
    let el = data[0];

    let limitObj = common.getInputLimit('quantity');
    const isReturn = common.getIsReturn(this.data);
    const isLaborCost = this.getIsLaborCost(targetIndex);
    if (!isLaborCost && !isReturn) {
      el.type = "positive"
      limitObj.abs = true
    }

    const voucherData = this.viewModel.getViewItem('Voucher').data;
    let record = voucherData[targetIndex];
    let uiState = record.uiState || {};
    uiState = uiState[fieldName] || {};

    Object.assign(el, limitObj, uiState);

    await this.waitInputAndDispatchController(fieldName, targetIndex, data);
  }

  //SingleSale单品打折
  async SingleSale(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      takeTheir: false
    });
    if (!isExEcute) return false;
    const fieldName = 'SingleSale';
    if (!this.checkUpdatePrice('单品打折', targetIndex)) {
      return false;
    }
    let data = filterField(fieldName);
    let el = data[0];

    let limitObj = common.getInputLimit('amount');
    limitObj.abs = true;

    const voucherData = this.viewModel.getViewItem('Voucher').data;
    let record = voucherData[targetIndex];
    let uiState = record.uiState || {};
    uiState = uiState['DiscountRate'] || {};

    Object.assign(el, limitObj, uiState);

    await this.waitInputAndDispatchController(fieldName, targetIndex, data);
  }

  //单品金额
  async SingleAmount(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      takeTheir: false
    });
    if (!isExEcute) return false;
    const fieldName = 'SingleAmount';
    $T.debugger();
    let result = this.checkUpdatePrice('单品金额', targetIndex);
    if (!result) {
      return false;
    }
    let data = filterField(fieldName);
    let el = data[0];

    let limitObj = common.getInputLimit('amount');
    const isReturn = common.getIsReturn(this.data);
    if (!isReturn) limitObj.abs = true;

    const voucherData = this.viewModel.getViewItem('Voucher').data;
    let record = voucherData[targetIndex];
    let uiState = record.uiState || {};
    uiState = uiState['TaxAmount'] || {};

    Object.assign(el, limitObj, uiState);
    await this.waitInputAndDispatchController(fieldName, targetIndex, data);
  }

  //整单打折
  async TotalSale(targetIndex) {
    const isExEcute = this.isExecute({
      takeTheir: false,
      have: true,
      index: targetIndex
    });
    if (!isExEcute) return false;
    if (!this.checkUpdatePrice('整单打折', -1)) {
      return false;
    }
    const fieldName = 'TotalSale';
    let data = filterField(fieldName);
    let el = data[0];

    let limitObj = common.getInputLimit('amount');
    limitObj.abs = true;

    //uiState 控制
    const bottomOperations = this.viewModel.getViewItem('Operations')
      .bottomOperations || [];
    const bottomOperation = bottomOperations.find(
      el => el.name == fieldName
    ) || {};
    const operationUiState = bottomOperation.uiState;

    Object.assign(el, limitObj, operationUiState);
    await this.waitInputAndDispatchController(fieldName, targetIndex, data);
  }

  //电子秤-归零
  async ReturnZero() {
    const isExEcute = this.isExecute({
      balance: true
    })
    if (!isExEcute) return false;
    HardwareAPI.handleBalEntryZero(null, ret => {
      let rt = ret ? JSON.parse(ret) : ret;
      if (!(rt && rt.error)) {
        Message.success('执行成功')
      } else {
        Message.error('执行失败')
      }
    })
  }

  //电子秤-去皮
  async Peel() {
    const isExEcute = this.isExecute({
      balance: true
    })
    if (!isExEcute) return false;
    HardwareAPI.handleBalEntryTare(null, ret => {
      let rt = ret ? JSON.parse(ret) : ret;
      if (!(rt && rt.error)) {
        Message.success('执行成功')
      } else {
        Message.error('执行失败')
      }
    })
  }

  //整单赠送
  async TotalPresent(targetIndex) {
    const isExEcute = this.isExecute({
      takeTheir: false,
      have: true,
      index: targetIndex
    });
    if (!isExEcute) return false;
    const fieldName = 'TotalPresent';
    runInAction(() => {
      this.controller[`update${fieldName}`] && this.controller[`update${fieldName}`]();
      this.setInventoryFocus();
    });
  }

  //赠品逻辑
  async Present(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      takeTheir: false,
    });
    if (!isExEcute) return false;
    console.log('进入赠品逻辑');
    const fieldName = 'Present';
    runInAction(() => {
      this.controller[`updateSingle${fieldName}`] && this.controller[`updateSingle${fieldName}`](targetIndex)
      this.setInventoryFocus();
    })
  }

  //抹零
  async WipeChange(targetIndex) {
    const isExEcute = this.isExecute({
      have: true,
      index: targetIndex
    });
    if (!isExEcute) return false;
    // 单品金额配置
    let invAmountsetting = PosInitData('invAmountsetting');
    // 成交金额配置
    let dealAmountSetting = PosInitData('dealAmountSetting');

    if (InvAmountsetting.Code_01 != invAmountsetting) {
      Message.warn('单品金额配置非实款实收，不能抹零');
      return false;
    }
    if (DealAmountSetting.Code_01 != dealAmountSetting) {
      Message.warn('成交金额配置非实款实收，不能抹零');
      return false;
    }

    const fieldName = 'WipeChange';
    const voucherVM = this.viewModel.getViewItem('Voucher');
    const taxAmountField = voucherVM.voucherDetail.find(
      el => el.FieldName === 'TaxAmount'
    );
    let data = filterField(fieldName);
    data[0].Value = this.data.TotalTaxAmount.toFixed(2);
    const updateProps = {
      precisionLength: taxAmountField.Precision,
      maxLength: taxAmountField.MaxLength,
    };
    data[1] = {
      ...data[1],
      ...updateProps,
    };
    let formData = {
      Title: '抹零金额',
      Data: data,
    };
    let formResult = await this.inputFormModal(formData);
    if (!formResult) return;
    let bizControllerName = `update${fieldName}`;
    await runInAction(async () => {
      this.controller[bizControllerName] &&
        (await this.controller[bizControllerName](formResult[fieldName]));
    })
  }

  //修改单据日期
  async VoucherDate() {
    const isExEcute = this.isExecute({
      takeTheir: false
    });
    if (!isExEcute) return false;
    let fieldMsg = filterField('VoucherDate');
    if (fieldMsg && fieldMsg.length == 1) {
      let field = fieldMsg[0];
      let voucherDate = this.data[field.FieldName];
      field.Value = voucherDate instanceof Date
        ? voucherDate
        : new Date(voucherDate);
      let formData = {
        Title: '修改日期',
        Data: fieldMsg,
        check: result => {
          if (!result[field.FieldName]) {
            return { Label: '单据日期不能为空！' };
          }
        },
      };
      let formResult = await this.inputFormModal(formData);
      if (formResult) {
        let retVoucherDate = formResult[field.FieldName];
        await this.controller.updateVoucherDate(retVoucherDate);
      }
    }
  }

  //录入自由项
  async FreeItem(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      takeTheir: false,
      serialNumber: true
    });
    if (!isExEcute) return false;
    if (!this.isEnableFreeItem(this.data.RetailDetails[targetIndex])) {
      Message.warn('当前商品无自由项!');
      return;
    }
    let retailDetail = this.data.RetailDetails[targetIndex];
    let inventory = toJS(retailDetail.Inventory);
    let RetailInventory = JSON.parse(
      tools.getDynamicProperty(
        inventory.DynamicPropertyKeys,
        inventory.DynamicPropertyValues,
        'inventoryinfo'
      )
    );
    /* 赋予自由项目默认值 */
    RetailInventory.FreeItems.forEach(el => {
      const value = JSON.getCellValue(retailDetail, el.Name);
      el.Value = value;
    });

    const inventoryFreeItemObj = {
      head: '自由项选择',
      data: {
        title: {
          name: t('商品名称'),
          value: RetailInventory.Name,
        },
        body: RetailInventory.FreeItems,
      },
      cancelEnable: true,
    };
    if (
      inventoryFreeItemObj.data.body &&
      inventoryFreeItemObj.data.body.length > 0
    ) {
      var result = await this.inputFreeItemsModal(inventoryFreeItemObj);
      if (!result) return;
      this.controller.updateFreeItem(result, targetIndex);
    }
  }

  //修改批号
  async Batch(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      serialNumber: true
    });
    if (!isExEcute) return false;
    let retailDetail = this.data.RetailDetails[targetIndex];
    let batchs; //批次信息
    /* 检验是否需要批号 */
    let Inventory = retailDetail.Inventory;

    let isBatch = Inventory.IsBatch;
    // if (!isBatch) {
    //   Message.warn('该商品不需要录入编号!');
    // }
    if (isBatch) {
      batchs = await this.checkBatch(retailDetail, true, null);
      if (batchs === void 0) return;
      //如果没有取到批号信息
      if (batchs.length !== 0) {
        const result = batchs.filter(el => el.Quantity !== 0);
        this.controller.updateBatch(result, targetIndex);
      }
    } else {
      Message.warn('当前商品无批号信息!');
    }
  }

  //序列号
  async SerialNumber(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      serialNumber: true,
      checkSerial: true
    });
    if (!isExEcute) return false;
    let retailDetail = this.data.RetailDetails[targetIndex];
    const inventoryName = (retailDetail.Inventory && retailDetail.Inventory.Name) || '';
    const serialNumber = retailDetail.SerialNumber;
    const serialNumberMemo = retailDetail.SerialNumberMemo;
    const result = await this.SerialNumberVM(inventoryName, serialNumber, serialNumberMemo);
    if (result) {
      runInAction(() => {
        const { field1, field2 } = result;
        this.controller['updateSerialNumber'] && this.controller['updateSerialNumber'](field1.Value, field2.Value, targetIndex);
      })
    }
  }
  //序列号-模态框
  async SerialNumberVM(inventoryName, serialNumber, serialNumberMemo) {
    let vm = this.viewModel.getViewItem('SerialNumber');
    return await vm.init({
      data: {
        head: {
          name: '商品名称',
          value: inventoryName,
        },
        body: {
          field1: {
            FieldName: 'SerialNumber',
            Value: serialNumber
          },
          field2: {
            FieldName: 'SerialNumberMemo',
            Value: serialNumberMemo
          }
        }
      }
    })
  }

  @operationLog('printRetail', '打印零售单')
  async printRetail({ openCashBox }) {
    let dto = this.viewModel.data;
    try {
      //等待1.5s 等支付成功的弹出框消失后再触发loading 两个事件独立  但要保证同步完成
      const openLoading = setTimeout(() => {
        Loading.show({
          text: '处理结算后操作,请稍等...',
        });
      }, 1500);
      await this.controller.printRetail(dto.ID, dto, openCashBox);
      clearTimeout(openLoading);
      Loading.hide();
    } catch (error) {
      alert(error);
      Loading.hide();
    }
  }

  //重新开单
  @operationLog('newRetailOrder', '重新开单')
  async NewRetailOrder() {
    this.isSetProductCursor = false;
    let status = AuthProcess.execute('ReverseOperation');
    if (!status) {
      this.authorityValidate({callback: (result) => {
        if (result) {
          ModalWraper.confirm({
            title: t('重新开单'),
            content: t('是否重新开单'),
            onOk: () => {
              this.clearVoucherData();
            },
            onCancel: () => {
              this.isSetProductCursor = true;
              this.setInventoryFocus();
            }
          })
        }
      }})
    } else {
      ModalWraper.confirm({
        title: t('重新开单'),
        content: t('是否重新开单'),
        onOk: () => {
          this.clearVoucherData();
        },
        onCancel: () => {
          this.isSetProductCursor = true;
          this.setInventoryFocus();
        }
      })
    }
  }

  /* 清空单据所有数据 */
  @operationLog('clearVoucherData', '清空单据信息')
  async clearVoucherData(params) {
    //用户信息
    const userId = PosInitData('UserId');
    const userName = PosInitData('UserName');
    const userParams = JSON.stringify({ userId, userName });
    try {
      serverLog('newretail', { eventId: 'SettleSuccessProcess_clearVoucherData_before', param: userParams });
      await this.controller.initData();  // 清空 DataModel
      serverLog('newretail', { eventId: 'SettleSuccessProcess_clearVoucherData_initData_after', param: userParams });
      this.setMemberProductCursor();
      const { keep } = params || {}
      if (keep === true) return;
      this.callGuestShow(5);
    } catch (error) {
      serverLog('newretail', { eventId: 'SettleSuccessProcess_clearVoucherData_error', param: userParams });
    }
  }

  /* 结算校验 */
  authorityValidate({callback}) {
    UiCommon.mask({});
    // 需要异步校验
    return new Promise((resolve, reject)=>{
      this.controller.authorityValidate().then((result)=>{
        UiCommon.deleteMask({async:true});
        callback && callback(result);
        resolve(result)
      }).catch((err)=>{
        console.warn(err)
        UiCommon.deleteMask({async:true});
      })
    });
  }

  //选导购员
  async GetGuide(targetIndex) {
    //tuzh  如果是原单退货，且导购员有值，则不能修改
    if (this.isOriginalReturn()) {
      if (
        (targetIndex > -1 &&
          this.isOriginalReturnDetail(targetIndex) &&
          this.data.RetailDetails[targetIndex].Idperson) ||
        (targetIndex == -1 && this.data.Idperson)
      ) {
        Message.warn('原单退货不能修改导购员');
        return false;
      }
    }
    const result = await this.inputGuide();
    const { guide, choice } = result;
    if (guide) {
      if ('all' === choice) {
        runInAction(() => {
          this.controller.updateGuide(guide);
        });
      } else if ('single' === choice) {
        if (targetIndex === -1) {
          Message.warn('请先点击选中一行商品');
        } else {
          runInAction(() => {
            this.controller.updateSingleGuide(guide, targetIndex);
          });
        }
      }
    }
  }

  async inputGuide() {
    let guideModal = this.viewModel.getViewItem('GuideModal');
    return new Promise((resolve, reject) => {
      guideModal.show(result => {
        resolve(result);
      })
    })
  }

  //修改单位
  async Unit(targetIndex) {
    const isExEcute = this.isExecute({
      single: true,
      index: targetIndex,
      takeTheir: false,
      originalReturn: false,
      serialNumber: true
    });
    if (!isExEcute) return;
    let retailDetail = this.data.RetailDetails[targetIndex];
    let inventory = retailDetail.Inventory;
    let inventoryinfo = JSON.parse(
      tools.getDynamicProperty(
        inventory.DynamicPropertyKeys,
        inventory.DynamicPropertyValues,
        'inventoryinfo'
      )
    );
    let isSingleUnit = retailDetail.Unit.IsSingleUnit;
    if (isSingleUnit) {
      // 单计量存货
      Message.warn(t('单计量存货不能修改计量单位!'));
      return;
    }
    let ranges = inventoryinfo['UnitRanges'] || [];
    let oldData = retailDetail.Unit && retailDetail.Unit.Name;

    let inventoryName = inventory.Name;
    let input = {
      head: '修改单位',
      data: {
        title: {
          name: t('商品名称'),
          value: inventoryName,
        },
        body: [
          {
            Name: 'Unit',
            Value: '',
            Title: '单位',
            FreeItemRanges: ranges,
            Value: oldData,
          },
        ],
      },
      cancelEnable: true,
    };
    let result = await this.inputFreeItemsModal(input);

    if (!(result && result.length > 0)) {
      return;
    }
    var freeItemRanges = result[0].FreeItemRanges;
    var name = result[0].Value;
    let newUnit = null;
    freeItemRanges.forEach(item => {
      if (name == item.Name) {
        newUnit = item;
      }
    });
    this.controller.updateUnit &&
      this.controller.updateUnit(retailDetail, {
        index: targetIndex,
        updateProp: {
          name: 'Unit.Name',
          oldData: oldData,
          newData: newUnit,
        },
      });
  }

  /**
 * 录入会员后，不能修改单价，金额，折扣
 * @param {*} titleArgs
 */
  checkUpdatePrice(titleArgs, index) {
    if (this.data.Idmember && this.data.Idmember > 0) {
      // 会员优惠允许打折
      let isCanDiscountAfterMember = PosInitData('isCanDiscountAfterMember');
      if ('1' != isCanDiscountAfterMember) {
        let message = '享受会员优惠后不允许执行该操作!';
        Message.warn(message.Format(titleArgs));
        return false;
      }
    }
    const isTakeTheir = this.getIsTakeTheir();
    if (isTakeTheir) {
      Message.warn(t('自提商品不允许执行该操作!'));
      return false;
    }

    let operations = PosInitData('FunctionAuth');
    let SingleSaleIndex = -1;
    if (operations) {
      SingleSaleIndex = operations.findIndex(operation => {
        let operationName = (operation + '').toLowerCase();
        let operationNameTemp = ('UpdateDiscount' + '').toLowerCase();

        if (operationName.lastIndexOf(operationNameTemp) >= 0) {
          return true;
        }
      });
    }

    //是否允许促销后改价 by tuzha 2021-06-28
    let isChangePriceAfterPromo = true;
    if (Array.isArray(operations)) {
      isChangePriceAfterPromo = operations.includes('ChangePriceAfterPromo');
    }

    if (SingleSaleIndex < 0) {
      // 没有单品打折的情况
      let message = '没有单品打折的权限，不允许该操作!';
      Message.warn(message.Format(titleArgs));
      return false;
    }
    //tuzha 参与促销的明细行，不允许手工改价

    let hasPromotion = false;
    if (index >= 0 && this.data.RetailDetails[index].PromotionIdStr) {
      hasPromotion = true;
    }
    if (index < 0) {
      //整单类的，需要判断是否所有的明细都走了促销
      hasPromotion =
        this.data.RetailDetails.findIndex(it => !it.PromotionIdStr) == -1;
    }

    //如果执行了促销，且没有允许促销后改价的权限，则提示。
    if (hasPromotion&&!isChangePriceAfterPromo) { 
      let message = '享受促销优惠后不允许执行该操作!';
      Message.warn(message.Format(titleArgs));
      return false;
    }

    for (
      let tempIndex = 0;
      tempIndex < this.data.RetailDetails.length;
      tempIndex++
    ) {
      const detail = this.data.RetailDetails[tempIndex];
      let tempDetail = null;
      if (index == -1) {
        // tempDetail = detail;
      } else {
        if (tempIndex == index) {
          tempDetail = detail;
        }
      }
      if (tempDetail && tempDetail.IsPresent) {
        let message = '赠品不能修改{0}!';
        Message.warn(message.Format(titleArgs));
        return false;
      }
    }
    return true;
  }

  /**
   * 检验数量
   * @param {*} titleArgs
   * @param {*} index
   */
  checkQuantity(titleArgs, index, quantity = 0) {
    const horizontalPad = env.horizontalPad();
    if (!!horizontalPad) return true;
    let detail = this.data.RetailDetails[index];
    if (detail.Inventory.IsWeigh) {
      // 称重商品允许手工修改数量
      let isBalanceCanChange = PosInitData('isBalanceCanChange');
      if ('1' != isBalanceCanChange) {
        let message = '称重商品不允许手工修改{0}!';
        // throw new BizError(message.Format(titleArgs));
        Message.warn(message.Format(titleArgs));
        return false;
      }
    }
    return true;
  }

  //等待用户输入内容控制 并传入业务控制器
  async waitInputAndDispatchController(fieldName, targetIndex, data) {
    let _this = this;
    if (data.length) {
      let formData = {
        Title: data[0].Title,
        Data: data,
      };

      let formResult = await this.inputFormModal(formData);
      if (formResult && formResult[fieldName]) {
        let inputResult = formResult[fieldName];
        if (inputResult) {
          runInAction(() => {
            if (targetIndex !== undefined) {
              this.controller[`update${fieldName}`] && this.controller[`update${fieldName}`](inputResult, targetIndex);
              this.triggerGuestShow(targetIndex);
            } else {
              this.controller[`update${fieldName}`] && this.controller[`update${fieldName}`](inputResult);
            }
          });
        }
      }
    }
  }

  /* =====================================底部按钮区域的操作end===================================*/

  /* =====================================促销方案start===================================*/

  async onDeductionValidate({callback}) {
    let resultValidate = await this.controller.onValidateForMemberDeduction();
    callback && callback(resultValidate)
  }

  async onValidate() {
    //先检查是促销方案
    const result = await this.checkPromotion();
    console.log(this.data);
    const voucher = this.viewModel.items.find(it => it.type === 'Voucher');
    if (result) {
      // 提交时，前段校验
      var resultValidate = await this.controller.onValidate();
      if (!resultValidate) {
        voucher.enableSettlement(false);
        // return false;
        //校验失败，需要回滚促销
        if (result) {
          this.controller.cancelPromotion(true);
        }
      } else {
        //tuzha 处理原单退货的结算方式
        if (this.isOriginalReturn()) {
          await this.controller.OriginalReturnPayment();
        }
        voucher.enableSettlement(true);
      }
    } else {
      voucher.enableSettlement(false);
      return false;
    }
  }

  @action async checkPromotion() {
    if (platform.isVerticalTouch) {
      //自助收银
      await this.controller.startSelfPromotions();
      return true;
    }

    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    const visible = await this.controller.startPromotions();
    // 是否有促销方案
    if (visible) {
      const showPromotions = await this.controller.calcNextPromotions();
      planList.load(
        showPromotions.map(it => ({
          key: it.ID,
          title: it.PromotionTypeName,
          description: it.PromotionDesc,
          extra: it.PromotionCode,
        }))
      );
      if (planList.items.length === 1) {
        planList.select(planList.items[0].key);
        if (await this.checkSelectedPromotion()) {
          // voucher.enableSettlement(true);
          return true;
        }
        return new Promise(resolve => {
          const cur = planList.activeDetail;
          when(
            () => cur.visible === false,
            () => {
              if (cur.reason === 'cancel') {
                this.cancelPromotion();
              }
              // voucher.enableSettlement(cur.reason === 'ok');
              resolve(cur.reason === 'ok');
              // return ;
            }
          );
        });
      } else {
        planList.show();
        return new Promise(resolve => {
          when(
            () => planList.visible === false,
            () => {
              // voucher.enableSettlement(planList.result === 'ok');
              resolve(planList.result === 'ok');
              // return ;
            }
          );
        });
      }
    } else {
      // 没有促销方案
      // voucher.enableSettlement(true);
      return true;
    }
  }

  // 检查是否需要显示赠品列表，否则可以执行促销
  async checkSelectedPromotion() {
    if (!await this.checkPromotionDetail()) {
      await this.executePromotion();
      return true;
    }
  }

  // 执行当前方案并且调整还可以选择的方案
  async executePromotion() {
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    // 执行当前选中的促销方案
    const list = planList.activeDetail.tabs[0].rows.filter(
      it => it.Quantity > 0
    );
    const gifts = await this.controller.calcPromotionGifts(
      planList.activeItem.key
    );
    if (list.length <= 0 && gifts) {
      // 没选赠品需要把选中的方案移除
      planList.activeItem.remove();
    } else {
      await this.controller.executePromotion(planList.activeItem.key, list);
    }
    // 计算还显示的促销方案
    const showPromotions = await this.controller.calcNextPromotions();
    // 设置显示项
    planList.setVisible(showPromotions.map(sit => sit.ID));
    this.hideMoreButtons();
  }

  // 合并相同存货+自由行的行
  mergeBys = ('FreeItem0,FreeItem1,FreeItem2,FreeItem3,FreeItem4,FreeItem5,FreeItem6,FreeItem7,FreeItem8,FreeItem9' +
    ',Idinventory,Idunit,Batch,ProductionDate,ExpiryDate,RetailPrice,TaxPrice,DiscountRate,MemberDiscountRate,SerialNumber').split(
      ','
    );
  // 检查是否需要录入赠品明细或打折商品
  async checkPromotionDetail() {
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    const planData = planList.activeDetail;
    // 获取促销方案的赠品或折扣商品信息
    const gifts = await this.controller.calcPromotionGifts(
      planList.activeItem.key
    );
    if (!gifts) {
      planData.hide();
      return false;
    }
    let columns = await this.controller.calcPromotionColumns(
      planList.activeItem.key
    );
    if (columns.length > 5) columns[0].fixed = 'left';
    const currentPlan = (await this.controller.calcNextPromotions()).find(
      it => it.ID === planList.activeItem.key
    );
    // // 整单满单品优惠
    if (currentPlan.PromotionType === PromotionType.DR_PromotionType_04) {
      planData.createTabs(2);
      planData.tabs[0].setColumns(
        t('本单优惠商品'),
        [],
        this.mergeBys,
        'Quantity',
        'Inventory.Code',
        'update'
      );
      planData.tabs[1].setColumns(
        t('可优惠商品'),
        columns,
        [
          'Idinventory',
          'Idunit',
          'IdInventoryClass',
          'InventoryClass.Code',
          'CorpBrand.Name',
          'CorpBrand.Id',
          'DiscountAmount',
          'DiscountRate',
        ],
        'Quantity',
        'Inventory.Code',
        'update'
      );
      planData.tabs[1].load(gifts.data);
      planData.tabs[1].setInfo(t('注：可优惠商品为本次促销的商品优惠范围'), false, true);
    } else {
      planData.createTabs(1);
      planData.tabs[0].setColumns(
        null,
        columns,
        this.mergeBys,
        'Quantity',
        'Inventory.Code',
        'update'
      );
      planData.tabs[0].load(gifts.data);
    }
    planData.show(
      planList.activeItem.title,
      currentPlan.PromotionType === PromotionType.DR_PromotionType_04
        ? null
        : gifts.total
    );
    return true;
  }

  // 检查存货特性，是否需要录入自由项、价格、批次等
  async checkInventoryProps() {
    const planItem = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    ).activeItem;
    const dataTable = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    ).activeDetail.tabs[0];
    const currentPlan = (await this.controller.calcNextPromotions()).find(
      it => it.ID === planItem.key
    );
    const length = dataTable.data.length;
    // 补录数据
    for (const it of dataTable.data) {
      // if (it.Batch && it.Batch.reduce((sum, it) => sum + it.Quantity, 0) !== it.Quantity) {
      //   // 有批次但是修改了数量清空批次从新选择
      //   dataTable.updateRow(dataTable.data.indexOf(it), {
      //     Batch: null
      //   });
      // }

      // 赠品有数量就需要检查
      if (it.Quantity > 0 && !it.checked && !it.Inventory.IsSerialNumber) {
        it.checked = true;
        // const {
        //   RetailDetail
        // } = await ProductApi.getProductDetail({
        //   IdInventory: it.Inventory.ID,
        //   IsReturn: isReturn
        // });

        const { RetailDetail } = await this.controller.getInventoryInfo(
          planItem.key,
          it.Inventory.ID,
          it.Inventory.Code
        );

        if (!RetailDetail) {
          return false;
        }
        const detailDto = JSON.parse(RetailDetail);
        let raw = dataTable.data.indexOf(it);
        //tuzh 如果没有零售价，且加价卖，需要给出提示
        // if (it.TaxPrice > 0 && (!detailDto.RetailPrice || detailDto.RetailPrice == 0)) {
        //   dataTable.updateRow(raw, { Quantity: 0 })
        //   Message.warn(t('赠品零售价未设置金额，不能进行加价赠送！'));
        //   return
        // }

        detailDto.TaxPrice = it.TaxPrice;
        detailDto.checked = it.checked;
        const Inventory = JSON.parse(RetailDetail).Inventory;
        const inventoryinfo = tools.getDynamicProperty(
          Inventory.DynamicPropertyKeys,
          Inventory.DynamicPropertyValues,
          'inventoryinfo'
        );
        const inventoryObj = JSON.parse(inventoryinfo);

        let isValid = await this.checkPromotionQuantityRule(
          it,
          currentPlan,
          dataTable
        );
        if (!isValid && it.Quantity == 0) {
          it.checked = false;
          return false;
        }
        detailDto.Batch = it.Batch;
        detailDto.ExpiryDate = it.ExpiryDate;
        detailDto.ProductionDate = it.ProductionDate;
        detailDto.Quantity = it.Quantity;

        //合并动态属性
        const dynamicPropertyKeys = detailDto.DynamicPropertyKeys;
        const dynamicPropertyValues = detailDto.DynamicPropertyValues;
        detailDto.DynamicPropertyKeys = it.DynamicPropertyKeys;
        detailDto.DynamicPropertyValues = it.DynamicPropertyValues;

        runInAction(() => {
          for (let i = 0; i < dynamicPropertyKeys.length; i++) {
            const value = dynamicPropertyKeys[i];
            if (value) {
              const index = detailDto.DynamicPropertyKeys.findIndex(
                it => it == value
              );
              if (index < 0) {
                detailDto.DynamicPropertyKeys[i] = dynamicPropertyKeys[i];
                detailDto.DynamicPropertyValues[i] = dynamicPropertyValues[i];
              }
            }
          }
        });
        //校验自由项必录
        isValid = await this.checkPromotionFreeItemRule(
          raw,
          detailDto,
          dataTable,
          true
        );
        if (!isValid || length > dataTable.data.length) {
          return false;
        }
        //处理自由项信息
        for (let index = 0; index < 10; index++) {
          let freeItemName = 'freeitem' + index.toString();
          let discountFreeItemName = 'FreeItem' + index.toString();
          JSON.setCellValue(detailDto, freeItemName, it[discountFreeItemName]);
          detailDto[discountFreeItemName] = it[discountFreeItemName];
        }
        // raw = dataTable.data.indexOf(it);
        dataTable.updateRow(raw, detailDto);
        //批号不必录时，促销选赠品时也不控制批号必录 by tuzha 2020-06-01
        let isBatchNumberViladate = PosInitData('Isbatchnumberviladate');
        //检验批号
        if (inventoryObj.IsBatch && isBatchNumberViladate == "1") {
          await this.checkPromotionBatchRule(
            raw,
            detailDto,
            dataTable,
            true,
            currentPlan
          );
        }
      }
      // 检查价格规则
      await this.checkPromotionPriceRule(it, currentPlan, dataTable);
    }
    if (dataTable.currentRow) {
      // if (dataTable.currentRow.TaxPrice > 0 && (!dataTable.currentRow.RetailPrice || dataTable.currentRow.RetailPrice == 0)) {
      //   dataTable.updateRow(dataTable.data.indexOf(dataTable.currentRow), { Quantity: 0 })
      //   Message.warn(t('赠品零售价未设置金额，不能进行加价赠送！'));
      //   return
      // }
      // 验证最大数量
      await this.checkPromotionQuantityRule(
        dataTable.currentRow,
        currentPlan,
        dataTable
      );
      this.checkMoreActions({ rowIndex: 0 });
    }
  }

  async checkPromotionFreeItemRule(rowIndex, detailDto, dataTable, isFirst) {
    const Inventory = detailDto.Inventory;
    const inventoryinfo = tools.getDynamicProperty(
      Inventory.DynamicPropertyKeys,
      Inventory.DynamicPropertyValues,
      'inventoryinfo'
    );
    if (!inventoryinfo) {
      return false;
    }
    const inventoryObj = JSON.parse(inventoryinfo);

    if (inventoryObj.FreeItems && inventoryObj.FreeItems.length > 0) {
      /* 赋予自由项目默认值 */
      let hasFreeItem = true; //是否有默认值
      inventoryObj.FreeItems.forEach(el => {
        const value = JSON.getCellValue(detailDto, el.Name);
        if (!value) {
          hasFreeItem = false;
        }
        el.Value = value;
      });
      if (isFirst && hasFreeItem) {
        dataTable.updateRow(
          rowIndex,
          inventoryObj.FreeItems.reduce((obj, el) => {
            return {
              ...obj,
              [el.Name]: el.Value,
            };
          }, {})
        );
      } else {
        var freeitems = await this.inputFreeItemsModal({
          head: '自由项选择',
          data: {
            title: {
              name: t('商品名称'),
              value: inventoryObj.Name,
            },
            body: inventoryObj.FreeItems,
          },
          cancelEnable: true,
        });
        if (freeitems === void 0 && isFirst) {
          dataTable.updateRow(rowIndex, { Quantity: 0, checked: false });
          return false;
        }

        dataTable.updateRow(
          rowIndex,
          freeitems.reduce((obj, el) => {
            return {
              ...obj,
              [el.Name]: el.Value,
            };
          }, {})
        );
      }
    }
    return true;
  }

  async checkPromotionBatchRule(raw, it, dataTable, isFirst, currentPlan) {
    if (
      isFirst &&
      ((it.Batch && it.ExpiryDate && it.ProductionDate) ||
        (!it.Inventory.IsQualityPeriod && it.Batch))
    ) {
      return;
    }

    const batchs = (await this.checkBatch(it, true, null)) || [];
    runInAction(() => {
      let selectBatchs = batchs.filter(el => el.Quantity >= 1);
      if (selectBatchs.length == 0 && isFirst) {
        dataTable.updateRow(raw, { Quantity: 0, checked: false });
        return;
      }
      selectBatchs.forEach((batch, i) => {
        if (i == 0) {
          it.Quantity = parseInt(batch.Quantity);

          dataTable.updateRow(raw, {
            Batch: batch.Batch,
            Quantity: it.Quantity,
            // Quantity2: batch.Quantity2,
            ExpiryDate: it.Inventory.IsQualityPeriod
              ? batch.ExpiryDate instanceof Date
                ? batch.ExpiryDate
                : new Date(batch.ExpiryDate)
              : undefined,
            ProductionDate: it.Inventory.IsQualityPeriod
              ? batch.ProductionDate instanceof Date
                ? batch.ProductionDate
                : new Date(batch.ProductionDate)
              : undefined,

          });
          this.checkPromotionQuantityRule(
            dataTable.currentRow,
            currentPlan,
            dataTable
          );
        } else {
          let splitDetail = _cloneDeep(toJS(it));
          splitDetail.Batch = batch.Batch;
          splitDetail.Quantity = batch.Quantity;
          // splitDetail.Quantity2 = batch.Quantity2;
          if (it.Inventory.IsQualityPeriod) {
            // 失效日期
            splitDetail.ExpiryDate = batch.ExpiryDate;
            // if (batch.ExpiryDate instanceof Date) {
            //   splitDetail.ExpiryDate = batch.ExpiryDate;
            // }
            // else {
            //   splitDetail.ExpiryDate = new Date(batch.ExpiryDate);
            // }

            // 生产日期
            splitDetail.ProductionDate = batch.ProductionDate;
            // if (batch.ExpiryDate instanceof Date) {
            //   splitDetail.ProductionDate = batch.ProductionDate;
            // }
            // else {
            //   splitDetail.ProductionDate = new Date(batch.ProductionDate);
            // }
          }
          // splitDetail.UnitExchangeRate = batch.UnitExchangeRate;
          dataTable.addRow(splitDetail);
          this.checkPromotionQuantityRule(splitDetail, currentPlan, dataTable);
        }
      });
    });

    // } else {
    //   dataTable.updateRow(dataTable.data.indexOf(it), {
    //     Batch: batchs.filter((el) => el.Quantity > 0),
    //     Quantity: batchs.reduce((q, it) => it.Quantity + q, 0)
    //   });
    // }
  }

  async checkPromotionPriceRule(currentRow, currentPlan, dataTable) {
    // 促销价格
    await this.controller.checkPromotionPrice(currentPlan.ID, [currentRow]);
  }

  async checkPromotionQuantityRule(currentRow, currentPlan, dataTable) {
    // 验证最大数量
    const isValid = await this.controller.checkPromotionQuantity(
      currentPlan.ID,
      dataTable.data,
      currentRow
    );
    if (!isValid) {
      Message.warn(t('赠品数量超过限制！'));
    }
    return isValid;
  }

  async searchPromotionGift({ value }) {
    const planItem = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    ).activeItem;
    const planDetail = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    ).activeDetail;
    const dataTable = planDetail.tabs[0];
    if (!value) {
      Message.warn(t('请输入商品编码或条码'));
      return;
    }
    const {
      InventoryResult,
      ViewInfos,
    } = await this.controller.getInventoryData(planItem.key, value);

    const currentPlan = (await this.controller.calcNextPromotions()).find(
      it => it.ID === planItem.key
    );
    //tuzh 一码多物的逻辑要提前判断
    if (InventoryResult) {
      if (InventoryResult.TotalCount > 1) {
        // 一码多物
        const isBarCode = InventoryResult.IsBarCode;
        const isSerialNumber = InventoryResult.IsSerialNumber;
        planDetail.showSelector(
          t('商品选择'),
          ViewInfos,
          InventoryResult.InventoryData
        );
        when(
          () => planDetail.visibleSelector === false,
          async () => {
            if (planDetail.selectorResult !== 'ok') {
              return;
            }
            if (planDetail.selectRow) {
              if (isBarCode) {
                const {
                  ViewInfos,
                  RetailDetail,
                } = await this.controller.getInventoryInfo(
                  planItem.key,
                  planDetail.selectRow.Id,
                  planDetail.selectRow.BarCode
                );
                const data = JSON.parse(RetailDetail);
                if (ViewInfos) {
                  dataTable.mergeColumns(ViewInfos);
                }
                this.handleData(currentPlan, dataTable, data,isSerialNumber);
              } 
              else if (isSerialNumber) //如果是序列号
              {
                const {
                  ViewInfos,
                  RetailDetail,
                } = await this.controller.getInventoryInfo(
                  planItem.key,
                  planDetail.selectRow.Id,
                  planDetail.selectRow.BarCode,
                  planDetail.selectRow.SerialNumberId
                );
                const data = JSON.parse(RetailDetail);
                if (ViewInfos) {
                  dataTable.mergeColumns(ViewInfos);
                }
                this.handleData(currentPlan, dataTable, data,isSerialNumber);
              }
              else {
                const {
                  ViewInfos,
                  RetailDetail,
                } = await this.controller.getInventoryInfo(
                  planItem.key,
                  planDetail.selectRow.Id,
                  planDetail.selectRow.Code,
                  ''
                );
                const data = JSON.parse(RetailDetail);
                if (ViewInfos) {
                  dataTable.mergeColumns(ViewInfos);
                }
                this.handleData(currentPlan, dataTable, data,isSerialNumber);
              }
            }
          }
        );
      } else {
        let data = JSON.parse(InventoryResult.RetailDetailData.RetailDetail);
        if (data) {
          if (ViewInfos) {
            dataTable.mergeColumns(ViewInfos);
          }
          if (!InventoryResult.IsSerialNumber && data.Inventory.IsSerialNumber) {
            Message.warn(t('此为序列号商品，请在商品录入框中录入序列号！'));
            return false;
          }
          if(!data.SerialNumberId)
          {
            const {
              ViewInfos,
              RetailDetail,
            } = await this.controller.getInventoryInfo(
              planItem.key,
              data.Idinventory,
              '',
              InventoryResult.InventoryData[0].SerialNumberId
            );
            data = JSON.parse(RetailDetail);
            if (ViewInfos) {
              dataTable.mergeColumns(ViewInfos);
            }
          }
          this.handleData(currentPlan, dataTable, data,InventoryResult.IsSerialNumber);
        }
      }
      planDetail.setActiveTab(0);
    }
  }
  //tuzha 处理接口返回的数据
  async handleData(currentPlan, dataTable, data,isSerialNumber) {
    
    if (!isSerialNumber && data.Inventory.IsSerialNumber) {
      Message.warn(t('此为序列号商品，请在商品录入框中录入序列号！'));
      return false;
    }

    if(isSerialNumber)//如果为序列号商品，则需要判断此序列号是否已经录入了
    {
      let isExist=dataTable.data.some(item=>data.SerialNumber===item.SerialNumber);
      if(isExist)
      {
        Message.warn(t('此序列号已经存在，请在商品录入框中录入其他序列号！'));
        return false;
      } 
    }
     
    //处理数量
    if (data.Quantity == 0) {
      data.Quantity = 1;
    }
    // 整单满单品优惠
    if (currentPlan.PromotionType === PromotionType.DR_PromotionType_04) {
      if (!data.RetailPrice) {
        Message.warn(t('该商品零售价为空，请到后台设置。'));
      } else {
        await this.controller.checkPromotionPrice(currentPlan.ID, [data]);

        if (!data.Batch) {
          data.Batch = null;
        }
        dataTable.addRow(data);
      }
    } else {
      let isValid = await this.controller.checkPromotionQuantity(
        currentPlan.ID,
        dataTable.data,
        data
      );
      if (!isValid) {
        Message.warn(t('赠品数量超过限制！'));
        return;
      }

      const detail = dataTable.data.find(
        c => c.Idinventory == data.Idinventory && c.Idunit == data.Idunit
      );
      if (!data.RetailPrice) {
        data.RetailPrice = 0;
      }
      data.TaxPrice = detail.TaxPrice;

      //解析默认自由项
      const Inventory = data.Inventory;
      const inventoryinfo = tools.getDynamicProperty(
        Inventory.DynamicPropertyKeys,
        Inventory.DynamicPropertyValues,
        'inventoryinfo'
      );
      if (inventoryinfo) {
        const inventoryObj = JSON.parse(inventoryinfo);
        if (inventoryObj.FreeItems && inventoryObj.FreeItems.length > 0) {
          //处理自由项信息
          inventoryObj.FreeItems.forEach(el => {
            const value = JSON.getCellValue(data, el.Name);
            data[el.Name] = value;
          });
          //}
        }
      }
      if (detail.Quantity == 0) {
        //合并动态属性
        const dynamicPropertyKeys = data.DynamicPropertyKeys;
        const dynamicPropertyValues = data.DynamicPropertyValues;
        data.DynamicPropertyKeys = detail.DynamicPropertyKeys;
        data.DynamicPropertyValues = detail.DynamicPropertyValues;
        runInAction(() => {
          for (let i = 0; i < dynamicPropertyKeys.length; i++) {
            const value = dynamicPropertyKeys[i];
            if (value) {
              const index = data.DynamicPropertyKeys.findIndex(
                it => it == value
              );
              if (index < 0) {
                data.DynamicPropertyKeys[i] = dynamicPropertyKeys[i];
                data.DynamicPropertyValues[i] = dynamicPropertyValues[i];
              }
            }
          }
        });
        if (!data.Batch) {
          data.Batch = detail.Batch;
          data.ExpiryDate = detail.ExpiryDate;
          data.ProductionDate = detail.ProductionDate;
        }
        dataTable.updateRow(dataTable.data.indexOf(detail), data);
      } else {
        // let isValid = await this.controller.checkPromotionQuantity(currentPlan.ID, dataTable.data, data);
        // if (isValid) {
        dataTable.addRow(data);
        // }
      }
    }
  }

  async cancelPromotion(
    arg = {
      clear: false,
    }
  ) {
    await this.controller.cancelPromotion(!arg.clear);
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    planList.clear();
  }

  initPlanConfig() {
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    planList.addMoreButtons('checkFreeItems', t('自由项'));
    planList.addMoreButtons('checkBatch', t('批次'));
  }

  hideMoreButtons() {
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    planList.setBtnVisible('checkFreeItems', false);
    planList.setBtnVisible('checkBatch', false);
  }

  checkMoreActions({ rowIndex }) {
    this.hideMoreButtons();
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    const dataTable = planList.activeDetail.tabs[0];
    if (dataTable.currentRow.Quantity > 0) {
      let hasFreeItem = false;
      for (let index = 0; index < 10; index++) {
        let FreeItemName = 'FreeItem' + index.toString();
        if (dataTable.currentRow[FreeItemName]) {
          hasFreeItem = true;
        }
      }
      // TODO 检查当前行是否有自由项
      if (hasFreeItem) {
        planList.setBtnVisible('checkFreeItems', true);
      }
      // TODO 是否有批次
      if (dataTable.currentRow.Inventory.IsBatch) {
        planList.setBtnVisible('checkBatch', true);
      }
    }
  }

  async executeMoreAction({ action }) {
    const planList = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    );
    const planItem = this.viewModel.items.find(
      it => it.type === 'PlanListModel'
    ).activeItem;
    const dataTable = planList.activeDetail.tabs[0];
    let raw = dataTable.data.indexOf(dataTable.currentRow);
    const currentPlan = (await this.controller.calcNextPromotions()).find(
      it => it.ID === planItem.key
    );
    const detailDto = dataTable.currentRow;
    if (detailDto.Inventory.IsSerialNumber) {
      Message.warn(t('序列号商品不可修改自由项、批次！'));
      return false;
    }
    if (action === 'checkFreeItems') {
      // TODO 执行选择自由项
      await this.checkPromotionFreeItemRule(
        raw,
        dataTable.currentRow,
        dataTable,
        false
      );
      //处理自由项信息
      for (let index = 0; index < 10; index++) {
        let freeItemName = 'freeitem' + index.toString();
        let discountFreeItemName = 'FreeItem' + index.toString();
        JSON.setCellValue(
          dataTable.currentRow,
          freeItemName,
          dataTable.currentRow[discountFreeItemName]
        );
      }
      dataTable.updateRow(raw, dataTable.currentRow);
    }
    if (action === 'checkBatch') {
      // TODO 执行选择批次
      await this.checkPromotionBatchRule(
        raw,
        dataTable.currentRow,
        dataTable,
        false,
        currentPlan
      );
    }
  }

  /* =====================================促销方案end===================================*/
  //tuzh 获取代金券、积分抵现、会员储值可用金额
  getAvailableAmount({ type }) {
    let availableAmount;
    if (this.controller['getAvailableAmount']) {
      availableAmount = this.controller['getAvailableAmount'](type);
    }
    const voucherVM = this.viewModel.getViewItem('Voucher');
    voucherVM.availableAmount = availableAmount;
  }
  /* =====================================批次修改start===================================*/
  batchUpdate({ index, record }) {
    const batchVM = this.viewModel.getViewItem('BatchModal');
    // batchVM.update(index,record)
    let operation = batchVM.batchsData[index];
    if (!operation) return;

    let updateProp = {
      name: '',
      oldData: '',
      newData: '',
    };
    batchVM.selectBatchView.forEach(el => {
      let key = el.dataIndex;
      if (key === 'Unit2' || key === 'Unit') return;
      if (record[key] !== operation[key]) {
        updateProp = {
          name: key,
          oldData: operation[key],
          newData: record[key],
        };
      }
    });
    let param = {};
    param.batchsData = batchVM.batchsData;
    param.index = index;
    param.updateProp = updateProp;
    param.updateRetailDetail = operation;
    this.controller.updateBatchDetail &&
      this.controller.updateBatchDetail(param); //调用controller方法
  }

  async batchUpdateFlow({ index, record, fieldName, column }) {
    const batchVM = this.viewModel.getViewItem('BatchModal');
    if (!common.getIsModifyQuantityAuth()) return;
    let result = await this.batchNumberModal(index, record, fieldName, column);
    record = {
      ...record,
      ...result,
    };
    this.batchUpdate({ index, record });
  }

  /* 弹框操作 */
  @action async batchNumberModal(index, record, fieldName, column) {
    const batchVM = this.viewModel.getViewItem('BatchModal');
    const isReturn = common.getIsReturn(this.data);
    const isLaborCost = batchVM.retailDetail.Inventory.IsLaborCost;
    let fieldDate = filterField(fieldName).map(el => {
      if (el.FieldName === 'Quantity' || el.FieldName === 'Quantity2') {
        Object.assign(el, common.getInputLimit('quantity'));
        if (!isLaborCost && !isReturn) el.type = 'positive';
        el.max = {
          value: column.maxValue,
        };
        el.min = {
          value: column.minValue,
        };
      }
      return el;
    });
    let formData = {
      Title: fieldDate[0].Title,
      Data: fieldDate,
      cancelable: true,
    };
    return await this.inputFormModal(formData);
  }
  /* =====================================批次修改end===================================*/

  /* =====================================会员储值start===================================*/

  @action async ValidateOperationName(dto) {
    let ret = await this.controller.ValidateOperationName(dto);
    const store = this.viewModel.getViewItem('Voucher');
    store.AuthType = ret;
  }

  /* =====================================会员储值end===================================*/
}

export default RetailOrderViewController;